import { render, staticRenderFns } from "./IntroductionForFaceUp.vue?vue&type=template&id=1fa0234b&scoped=true&"
import script from "./IntroductionForFaceUp.vue?vue&type=script&lang=ts&"
export * from "./IntroductionForFaceUp.vue?vue&type=script&lang=ts&"
import style0 from "./IntroductionForFaceUp.vue?vue&type=style&index=0&id=1fa0234b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0234b",
  null
  
)

export default component.exports